import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserGQL } from '@app/generated/graphql';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ShareGuard {
  constructor(private userGql: UserGQL) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> {
    const shareToken = next.queryParamMap.get('share_token');
    const allowedPaths = [
      '/shared/insights/report-group/',
      '/shared/insights/report-group-cycle/',
    ];

    if (!shareToken || !allowedPaths.some((path) => state.url.includes(path))) {
      window.location.replace(environment.authentication.logoutUrl);
      return of(false);
    }

    // we use the user GQL to check if this share token is valid, the API will
    // return a temporary share token user for this token that includes it's
    // share context, such as the company associated with the token.
    // if the token is invalid, we redirect to the logout page.

    return this.userGql.fetch().pipe(
      map((res) => !!res.data.myUser),
      tap((isValid) => {
        if (!isValid) {
          window.location.replace(environment.authentication.logoutUrl);
        }
      }),
    );
  }
}
